import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import type { Vertical } from '../BrandLinks';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../BrandLinks.scss';

import icons from './icons';

interface Props {
  vertical: Vertical;
  active?: boolean;
}

const iconsWithAccents = [
  'casino-hu',
  'casino-it',
  'poker-hu',
  'poker-is',
  'poker-ca',
  'sports-sl'
];

const normalizeLocale = (locale: string) =>
  locale.startsWith('en') || locale.startsWith('es') ? locale.slice(0, 2) : locale;

const LocalizedIcon: React.FC<Props> = ({ vertical, active }) => {
  const locale = useSelector(select.locale.get);
  const iconName = `${vertical}-${normalizeLocale(locale)}`;
  const withAccent = iconsWithAccents.includes(iconName);

  return (
    <img
      src={icons[iconName] ?? icons[`${vertical}-en`]}
      alt={vertical}
      data-ot-ignore
      className={classNames(styles.icon, {
        [styles.active]: active,
        [styles.withAccent]: withAccent
      })}
    />
  );
};
export default LocalizedIcon;
